import axios from "axios";

import { baseAxios } from "config";

const updateInvoiceBatch = async ({ invoiceId, jobSlug, eventUrl, data }) => {
  const res = await baseAxios.put(
    `/payroll/invoices/${invoiceId}${jobSlug ? `?jobSlug=${jobSlug}` : ""}${
      eventUrl ? `?eventUrl=${eventUrl}` : ""
    }`,
    data
  );
  return res;
};

export default updateInvoiceBatch;
